import { List, ListHeader, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledList = styled(List) `
  align-self: stretch;
`;
export const StyledListHeader = styled(ListHeader) `
  padding-left: ${themeGet('spacing.md')};
`;
